import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a8{align-items:stretch;}.ssr-plugin'
import '.dh{box-shadow:0px 0px 15px 0px rgba(0, 0, 0, 0.15);}.ssr-plugin'
import '.av{border-radius:1.25rem;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.c0{overflow-y:auto;}.ssr-plugin'
import '.f3{height:98dvh;}.ssr-plugin'
import '.f4{width:98vw;}.ssr-plugin'
import '.eo{overflow-y:hidden;}.ssr-plugin'
import '.dw{height:min(50rem, 90vh);}.ssr-plugin'
import { styled } from 'inlines'
import { Authentication } from '../authentication/Authentication'
import { ModalWrapper } from './ModalWrapper'
import { AuthTab } from '../authentication/authTabs'
import useMediaQuery from '@app/util/useMediaQuery'

export type AuthModalProps = {
  isOpen: boolean
  tab: AuthTab
  onClose: (setUtm?: boolean) => void
  verificationTab?: AuthTab | null
}

export const AuthModal = ({
  isOpen,
  tab,
  onClose,
  verificationTab,
}: AuthModalProps) => {
  const isMobile = useMediaQuery()

  if (!isOpen) {
    return null
  }

  if (isMobile) {
    return (
      <ModalWrapper>
        <div className="d e a8 dh av t c0 f3 f4"
        >
          <Authentication
            tab={tab}
            onClose={onClose}
            verificationTab={verificationTab}
          />
        </div>
      </ModalWrapper>
    )
  }

  return (
    <ModalWrapper>
      <div className="d e a8 dh av t eo dw"
        style={{
          maxWidth: isMobile ? '90vw' : 'var(--max-width-modal)',}}
      >
        <Authentication
          tab={tab}
          onClose={onClose}
          verificationTab={verificationTab}
        />
      </div>
    </ModalWrapper>
  )
}
